import Navbar from "../components/navbar";
import { useEffect, useState } from "react";

function AboutUs() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {/* Hero Section */}
            <div className="relative min-h-[60vh] bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50">
                <Navbar />
                <div className="flex items-center justify-center text-center min-h-[60vh] px-6 lg:px-12">
                    <div
                        className={`transition-all duration-1000 ${isVisible
                                ? "opacity-100 translate-y-0"
                                : "opacity-0 translate-y-10"
                            }`}
                    >
                        <h1 className="text-4xl lg:text-6xl font-bold text-gray-900">
                            About{" "}
                            <span className="bg-gradient-to-r from-emerald-400 via-teal-500 to-green-400 bg-clip-text text-transparent">
                                AE Finance
                            </span>
                        </h1>
                        <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
                            Simplifying your loan journey with transparency, trust, and
                            technology — connecting you to the best loan options in the UAE.
                        </p>
                    </div>
                </div>
            </div>

            {/* Who We Are Section */}
            <section className="py-16 px-6 lg:px-12 bg-white">
                <div className="max-w-5xl mx-auto space-y-6 text-center">
                    <h2 className="text-3xl font-bold text-gray-900">Who We Are</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        <span className="font-semibold">AE Finance</span> is a digital platform owned and operated by{" "}
                        <span className="font-semibold">Ashomih Fintech Solutions FZC LLC</span>,
                        dedicated to making the loan search process simple, transparent, and
                        hassle-free for UAE residents.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        We connect you with top banks and financial partners so you can compare
                        multiple offers in one place, choose the best deal, and apply easily —
                        all online. Backed by technology and an experienced team, we believe in
                        putting you in control of your financial choices.
                    </p>
                </div>
            </section>

            {/* Mission & Vision */}
            <section className="py-16 px-6 lg:px-12 bg-gray-50">
                <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-start">
                    <div className="space-y-6">
                        <h2 className="text-3xl font-bold text-gray-900">Our Mission</h2>
                        <p className="text-lg text-gray-700 leading-relaxed">
                            Our mission at <span className="font-semibold">AE Finance</span> is to make personal and business financing
                            simple, transparent, and accessible for everyone in the UAE. We connect
                            you with trusted lenders, competitive offers, and clear information —
                            so you can make confident financial decisions.
                        </p>
                    </div>
                    <div className="space-y-6">
                        <h2 className="text-3xl font-bold text-gray-900">Our Vision</h2>
                        <p className="text-lg text-gray-700 leading-relaxed">
                            We envision a UAE where everyone — expats and locals alike — can easily
                            find the best loans and financial products, compare options confidently,
                            and reach their goals without hidden costs or hassle.
                        </p>
                    </div>
                </div>
            </section>

            {/* Our Approach */}
            <section className="py-16 px-6 lg:px-12 bg-white">
                <div className="max-w-6xl mx-auto text-center space-y-10">
                    <h2 className="text-3xl font-bold text-gray-900">Our Approach</h2>
                    <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
                        At <span className="font-semibold">AE Finance</span>, we believe in keeping things clear, honest, and
                        customer-focused. Here’s how we make finding a loan smarter for you:
                    </p>

                    <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            {
                                title: "Compare",
                                desc: "We bring offers from multiple trusted UAE banks to one place so you can see your best options."
                            },
                            {
                                title: "Choose",
                                desc: "We guide you to pick the loan that matches your needs, budget, and goals — no hidden surprises."
                            },
                            {
                                title: "Connect",
                                desc: "Once you’re ready, we connect you with the right bank or advisor for fast processing and support."
                            }
                        ].map((item, idx) => (
                            <div
                                key={idx}
                                className="p-6 bg-emerald-50 rounded-lg shadow hover:shadow-md transition"
                            >
                                <h3 className="text-xl font-semibold text-gray-800">
                                    {item.title}
                                </h3>
                                <p className="text-gray-700 mt-3 leading-relaxed">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50 py-10 px-6 lg:px-12">
                <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div>
                        <h3 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">
                            AE Finance
                        </h3>
                        <p className="mt-3 text-sm text-gray-400">
                            Your trusted partner for finding the best loan and credit card deals in the UAE & Pakistan.
                        </p>
                    </div>
                    <div>
                        <h4 className="text-lg font-semibold text-gray-800">Quick Links</h4>
                        <ul className="space-y-2 text-sm text-gray-600">
                            <li><a href="/bank-loan" className="hover:text-emerald-500">Bank Loans</a></li>
                            <li><a href="/credit-card" className="hover:text-emerald-500">Credit Cards</a></li>
                            <li><a href="/about" className="hover:text-emerald-500">About Us</a></li>
                            <li><a href="/contact" className="hover:text-emerald-500">Contact</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-lg font-semibold text-gray-800">Contact Us</h4>
                        <p className="text-sm text-gray-600">Email: info@aefinance.com</p>
                        <p className="text-sm text-gray-600">Phone: +971 55 1234567</p>
                        <p className="text-sm text-gray-600 mt-2">Dubai, UAE</p>
                    </div>
                </div>
                <div className="mt-8 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
                    © {new Date().getFullYear()} AE Finance. All Rights Reserved.
                </div>
            </footer>
        </div>
    );
}

export default AboutUs;
